import { useMemo } from 'react';

import { useRoleIds } from '@/contexts/ConfigContext';
import { cn } from '@/helpers/classnames';
import { IconAdministrators, IconDepartmentAdmin, IconSysadmin } from '@/icons';

interface RoleIconProps {
  roleId?: string;
  className?: string;
}

export const RoleIcon = ({ roleId, className }: RoleIconProps) => {
  const roleIds = useRoleIds();

  const icon = useMemo(() => {
    if (!roleId) return null;

    const iconClassName = cn('size-6 min-w-6', className);

    switch (roleId) {
      case roleIds.sysAdmin:
        return <IconSysadmin className={iconClassName} />;

      case roleIds.orgAdminWrite:
      case roleIds.orgBearerManager:
      case roleIds.orgAdminRead:
        return <IconAdministrators className={iconClassName} />;

      case roleIds.deptUser:
        return <IconDepartmentAdmin className={iconClassName} />;
      default:
        return null;
    }
  }, [roleId, className, roleIds]);

  return icon;
};
